export const whitelabelTextsDe = {
  home: {
    title: 'Suchen. Buchen. Nutzen.',
    subTitle:
      'kommunale Räume und Gegenstände sichtbar, buchbar und leicht zugänglich – für lebendige Orte, starke Gemeinschaften und gute Ideen.',
    offerRoomsSection: {
      title: 'Räume oder Gegenstände anbieten?',
      subTitle:
        'Kommunen, Vereine und gemeinnützige Organisationen können auf {{appName}} ihre Räume und Gegenstände für die gemeinschaftliche Nutzung zur Verfügung stellen.',
      btnRegisterLabel: 'Jetzt registrieren',
      btnLoginLabel: 'Anmelden'
    }
  },
  footer: {
    fundingNotice: {
      title: 'Förderhinweis',
      description:
        '„{{appName}}“ wird vom Kreis Mayen-Koblenz in Zusammenarbeit mit der Stadt Bamberg entwickelt und betrieben.',
      slr: 'Es ist Teil des <0>Modellprojektes Smart City</0>. Hierbei unterstützt das Bundesministerium für Wohnen, Stadtentwicklung und Bauwesen (BMWSB) 73 Modellkommunen bei der Entwicklung und Umsetzung digitaler Lösungen zur nachhaltigen und integrierten Stadtentwicklung.',
      slrTitle: 'Modellprojekt Smart City'
    }
  },
  about: {
    heading: {
      title: 'Über Dein Raum MYK – eine Initiative der smarten Region MYK10',
      description: ''
    },
    easyLanguage: {
      title: 'Informationen in Leichter Sprache',
      description:
        'Hier erklären wir das {{appName}} einfach und verständlich.',
      linkLabel: 'Zur Seite in leichter Sprache',
      linkTitle: 'Zur Seite in leichter Sprache navigieren'
    },
    content: [
      {
        title: '',
        description:
          'Unsere Kommunen verfügen über zahlreiche Räume, Geräte und Ausstattungen, die das öffentliche Leben möglich machen: von Gemeindehäusern und Mehrzweckräumen über Sport- und Veranstaltungsflächen bis hin zu Technik, Mobiliar und Materialien für Aktionen vor Ort. Diese Ressourcen sind da – doch oft schwer zu finden oder nur umständlich zu buchen.\n\nGenau hier setzt das Buchungsportal Dein Raum MYK an.'
      },
      {
        title: 'Die Idee',
        description:
          'Die Grundidee ist einfach: Kommunale Räume und Gegenstände sollen für gemeinwohlorientierte Zwecke leichter zugänglich und sichtbar werden. Das Portal bringt Informationen, Verfügbarkeit und Buchungsprozesse an einem Ort zusammen – übersichtlich, transparent und nutzerfreundlich. So können Bürgerinnen und Bürger, Vereine und Initiativen schnell sehen, welche Räumlichkeiten vorhanden sind, wie sie genutzt werden können und wann sie frei sind.\n\nWichtig ist dabei der Charakter des Angebots:\nDie Nutzung ist bewusst nicht kommerziell ausgerichtet. Das Portal versteht sich als Werkzeug zur Förderung von Ehrenamt, Nachbarschaft, Teilhabe und lokalem Engagement. Es geht nicht um Gewinn, sondern um gemeinschaftliche Nutzung kommunaler Ressourcen.'
      },
      {
        title: 'Die Entstehung',
        description:
          'Das Portal ist aus einem praktischen Bedarf entstanden: Vereine, Initiativen und engagierte Gruppen planen Veranstaltungen oder Projekte oft mit begrenzten Mitteln – und stoßen dabei regelmäßig auf dieselben Fragen:\n\n• Welche Räume oder Gegenstände stehen überhaupt zur Verfügung?\n• Wer ist zuständig?\n• Welche Regeln gelten?\n• Wie lässt sich die Nutzung fair und nachvollziehbar organisieren?\n• Wie hoch sind die Kosten?\n\nGleichzeitig möchten Verwaltungen Belegungen effizient koordinieren und den Aufwand für Rückfragen, Papierprozesse und Einzelabsprachen reduzieren.\nDas Ergebnis dieser Perspektiven ist ein gemeinsames Ziel: ein digitales, leicht zugängliches System, das das Miteinander vereinfacht.'
      },
      {
        title: 'Das Konzept',
        description:
          'Das Buchungsportal basiert auf drei Prinzipien:\n\n1. Transparenz:\nAlle relevanten Informationen sind an einem Ort gebündelt: Ausstattung, Nutzungsbedingungen, Ansprechpersonen und Verfügbarkeiten.\n2. Einfachheit:\nDer Buchungsprozess ist klar strukturiert – von der Suche mit spezifischen Bedarfen über die Anfrage bis zur Bestätigung.\n3. Gemeinwohlorientierung:\nDie Nutzung dient dem öffentlichen Interesse und unterstützt lokale Gemeinschaften. Falls Kostenbeiträge anfallen, stehen sie im Kontext von Betrieb, Pflege oder Aufwand – nicht als kommerzielle Einnahmequelle.'
      },
      {
        title: 'Was das Portal fördern möchte',
        description:
          'Dein Raum MYK soll dabei helfen,\n\n• Ehrenamt zu entlasten,\n• Kommunikation zu vereinfachen,\n• Ressourcen besser auszulasten,\n• Begegnung und Zusammenhalt zu stärken,\n• und gute Ideen schneller möglich zu machen.\n\nDenn lebendige Orte brauchen nicht immer neue Infrastruktur – oft genügt ein guter Zugang zu dem, was bereits da ist.'
      },
      {
        title: 'Wer steckt hinter Dein Raum MYK?',
        description:
          'Die Plattform wird von der Smarten Region MYK10, einer Stabstelle der Kreisverwaltung Mayen-Koblenz betrieben und ist Teil des Modellprojektes Smart City. Smart City ist ein Förderprogramm des Bundesministeriums für Wohnen, Stadtentwicklung und Bauwesen (BMWSB), in dem 73 Modellkommunen bei der Entwicklung und Umsetzung digitaler Lösungen zur nachhaltigen und integrierten Stadtentwicklung gefördert werden.'
      }
    ]
  }
};

export const whitelabelTextsEn = {
  home: {
    title: 'Searching. Booking. Using.',
    subTitle:
      'public rooms and materials visible, bookable and easily accessible – for lively places, strong communities and good ideas.',
    offerRoomsSection: {
      title: 'Offer rooms or items?',
      subTitle:
        'Municipalities, associations and non-profit organizations can make their rooms and items available for shared use on {{appName}}.',
      btnRegisterLabel: 'Register now',
      btnLoginLabel: 'Log in'
    }
  },
  footer: {
    fundingNotice: {
      title: 'Funding note',
      description:
        '{{appName}} is developed and operated by the district of Mayen-Koblenz in cooperation with the city of Bamberg.',
      slr: 'It is part of the <0>Smart City model project</0>. In this context, the Federal Ministry for Housing, Urban Development and Building (BMWSB) supports 73 model municipalities in developing and implementing digital solutions for sustainable and integrated urban development.',
      slrTitle: 'Smart City model project'
    }
  },
  about: {
    heading: {
      title: 'About {{appName}}',
      description: ''
    },
    easyLanguage: {
      title: 'Information in easy-to-read language',
      description:
        'Here we explain {{appName}} in simple, easy-to-understand words.',
      linkLabel: 'Go to the easy-to-read language page',
      linkTitle: 'Navigate to the easy-to-read language page'
    },
    content: [
      {
        title: '',
        description:
          'Our municipalities have many rooms, devices, and facilities that make public life possible: from community centers and multi-purpose rooms to sports and event venues, as well as technology, furniture, and materials for local activities. These resources exist — but they are often hard to find or only possible to book with a lot of effort.\n\nThis is exactly where the Dein Raum MYK booking portal comes in.'
      },
      {
        title: 'The idea',
        description:
          'The basic idea is simple: municipal rooms and items should become easier to access and more visible for public-benefit purposes. The portal brings information, availability, and booking processes together in one place — clear, transparent, and user-friendly. This way, residents, associations, and initiatives can quickly see which spaces are available, how they can be used, and when they are free.\n\nWhat matters is the character of the offer:\nUse is intentionally not commercially oriented. The portal is a tool to support volunteering, neighborhood life, participation, and local engagement. It is not about profit, but about shared use of municipal resources.'
      },
      {
        title: 'How it came about',
        description:
          'The portal grew out of a practical need: associations, initiatives, and engaged groups often plan events or projects with limited resources — and regularly run into the same questions:\n\n• Which rooms or items are actually available?\n• Who is responsible?\n• Which rules apply?\n• How can use be organized fairly and transparently?\n• What are the costs?\n\nAt the same time, administrations want to coordinate bookings efficiently and reduce the effort involved in follow-up questions, paper-based processes, and individual arrangements.\nThe result of these perspectives is a shared goal: a digital, easily accessible system that makes working together easier.'
      },
      {
        title: 'The concept',
        description:
          'The booking portal is based on three principles:\n\n1. Transparency:\nAll relevant information is bundled in one place: equipment, terms of use, contacts, and availability.\n2. Simplicity:\nThe booking process is clearly structured — from searching for specific needs, to the request, to confirmation.\n3. Public-benefit orientation:\nUse serves the public interest and supports local communities. If contributions to costs apply, they relate to operation, maintenance, or effort — not commercial revenue.'
      },
      {
        title: 'What the portal aims to support',
        description:
          'Dein Raum MYK is intended to help\n\n• relieve volunteers,\n• simplify communication,\n• make better use of resources,\n• strengthen encounters and cohesion,\n• and make good ideas possible faster.\n\nBecause lively places do not always need new infrastructure — often, good access to what already exists is enough.'
      },
      {
        title: 'Who is behind Dein Raum MYK?',
        description:
          'The platform is operated by the Smart Region MYK10, a staff unit of the Mayen-Koblenz district administration, and is part of the Smart City model project. Smart City is a funding program of the Federal Ministry for Housing, Urban Development and Building (BMWSB), in which 73 model municipalities are supported in developing and implementing digital solutions for sustainable and integrated urban development.'
      }
    ]
  }
};
